// Settings-page CRUD shape for dbo.facility (FORT-130). Distinct from
// Facility.tsx, which is the booking-aggregate view of a facility (embeds
// facility-type + metadata dictionary, used by the booking screen).
export interface FacilityRow {
    id: number;
    name: string;
    description: string | null;
    facilityTypeId: number;
    bookingIntervalMins: number;
    timezone: string;
    // Two independent out-of-service flags (FORT-401): isActive gates booking,
    // isVisible only decides whether the column renders on the admin grid.
    // Deliberately NOT coupled — hiding a court leaves it bookable elsewhere.
    isActive: boolean;
    isVisible: boolean;
}

export interface FacilityMetadataEntry {
    name: string;
    value: string;
}

// Booking interval bounds — kept in lock-step with the API validator
// (FacilitySettingsService.IsAllowedBookingInterval): positive integer in
// [5,120], divisible by 5. The presets below are the common cases; the
// Facilities settings panel also exposes a "Custom..." input that lets
// operators pick any value within these bounds.
export const BOOKING_INTERVAL_MIN_MINS = 5;
export const BOOKING_INTERVAL_MAX_MINS = 120;
export const BOOKING_INTERVAL_STEP_MINS = 5;

export const BOOKING_INTERVAL_PRESETS: ReadonlyArray<{ value: number; label: string }> = [
    { value: 5, label: '5 minutes' },
    { value: 10, label: '10 minutes' },
    { value: 15, label: '15 minutes' },
    { value: 30, label: '30 minutes' },
    { value: 45, label: '45 minutes' },
    { value: 60, label: '60 minutes' },
];

// Deprecated alias for callers that imported the original presets-only list.
// Kept so any unrelated imports of BOOKING_INTERVAL_OPTIONS still compile;
// new callers should use BOOKING_INTERVAL_PRESETS plus the bounds above.
export const BOOKING_INTERVAL_OPTIONS = BOOKING_INTERVAL_PRESETS;

export const isAllowedBookingInterval = (mins: number): boolean =>
    Number.isInteger(mins)
    && mins >= BOOKING_INTERVAL_MIN_MINS
    && mins <= BOOKING_INTERVAL_MAX_MINS
    && mins % BOOKING_INTERVAL_STEP_MINS === 0;
